import { cn } from "@/libs/utils";

type Props = {
  content: string;
  className?: string;
};
export default function CommonBadge({ content, className }: Props) {
  return (
    <div
      className={cn(
        "min-w-[45px] bg-green rounded-[20px] ml-[10px] px-[10px] py-[4px] text-white font-bold text-center",
        className
      )}
    >
      {content}
    </div>
  );
}
